import { createRootRoute, Link, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { Box, Typography, Paper } from '@mui/material';

import {
  ErrorBoundary,
  LoadingSpinner,
  VersionNotifier,
} from '@/components/common';
import { Footer, FooterProvider } from '@/components/layout';
import { AuthInitializer } from '@/components/auth/AuthInitializer';
import { LoadingOverlayProvider } from '@/components/loading';
import { ToastWrapper, DialogProvider } from '@/components/feedback';

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: ({ error }) => <ErrorBoundary error={error} />,
  pendingComponent: () => <LoadingSpinner />,
  notFoundComponent: () => (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          textAlign: 'center',
          maxWidth: { xs: '90%', sm: 500 },
        }}
      >
        <Typography variant='h4' component='h1' gutterBottom>
          Page Not Found
        </Typography>
        <Typography variant='body1' color='text.secondary' sx={{ mb: 2 }}>
          The page you're looking for doesn't exist.
        </Typography>
        <Link to='/' style={{ textDecoration: 'none' }}>
          <Typography variant='body1' color='primary'>
            Go back to home
          </Typography>
        </Link>
      </Paper>
    </Box>
  ),
});

function RootComponent() {
  return (
    <ToastWrapper>
      <DialogProvider>
        <LoadingOverlayProvider>
          <FooterProvider>
            <AuthInitializer>
              <VersionNotifier />
              <Outlet />
              <Footer />
              {import.meta.env.DEV && <TanStackRouterDevtools />}
            </AuthInitializer>
          </FooterProvider>
        </LoadingOverlayProvider>
      </DialogProvider>
    </ToastWrapper>
  );
}
